import { strings } from "../i18n/strings.es-AR.js";
import { conversation, sending, phase } from "../state/store.js";
import { theme, toggleTheme } from "../hooks/useTheme.js";
import { Icon } from "./icons.jsx";

// onRequestCloseSession: el diálogo de confirmación lo monta ChatScreen, no
// este header — `backdrop-blur` crea containing block y un `position: fixed`
// acá adentro se posicionaría contra la barra, no contra el viewport.
export function Header({ onRequestCloseSession }) {
  const { handoffActive, clientName, clientId } = conversation.value;
  // Con abonado identificado se muestra su número; si no, el nombre si existe.
  const accountLabel = clientId ? strings.abonadoLabel(clientId) : clientName || null;

  return (
    <header class="border-b border-white/10 bg-white/10 px-4 py-3 backdrop-blur">
      <div class="chat-col flex items-center gap-3">
      {/* Isotipo decorativo (alt=""): el nombre ya lo dice el <h1> de al lado.
          La caja de color la pone el CSS (mismo #3347ec que el ícono de la PWA)
          y el PNG va con fondo transparente, así el logo se lee igual en tema
          claro y oscuro. */}
      <img
        src="/img/logo-x.png"
        alt=""
        width="36"
        height="36"
        class="h-9 w-9 shrink-0 rounded-xl bg-flux-primary p-1.5"
      />
      <div class="min-w-0 flex-1">
        <h1 class="truncate text-sm font-semibold text-white">
          {strings.headerTitle}
          {accountLabel ? <span class="font-normal text-flux-cyan"> · {accountLabel}</span> : null}
        </h1>
        <p class="flex items-center gap-1.5 text-xs text-white/70">
          <span
            class={`inline-block h-2 w-2 rounded-full ${handoffActive ? "bg-flux-cyan" : "bg-flux-cyan-deep"}`}
          />
          {handoffActive ? strings.headerSubtitleAgent : strings.headerSubtitleBot}
        </p>
      </div>
      <button
        type="button"
        class="flex h-8 w-8 items-center justify-center rounded-full text-white/80 active:bg-white/20"
        onClick={() => toggleTheme()}
        title={strings.toggleTheme}
        aria-label={strings.toggleTheme}
      >
        <Icon name={theme.value === "dark" ? "sun" : "moon"} size={17} />
      </button>
      {/* "+" = cerrar sesión de la cuenta. Arranca un hilo limpio: revoca el
          registro del dispositivo, avisa al bot (cambiar_cuenta) y borra el
          historial local y del server. Ver closeSession(). Como el hilo se
          borra de verdad y no hay deshacer, va con confirmación. */}
      <button
        type="button"
        class="flex h-8 w-8 items-center justify-center rounded-full bg-white/15 text-white active:bg-white/30 disabled:opacity-40"
        disabled={sending.value || phase.value !== "ready"}
        onClick={onRequestCloseSession}
        title={strings.closeSession}
        aria-label={strings.closeSession}
      >
        <Icon name="plus" size={17} />
      </button>
      </div>
    </header>
  );
}
